var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"faq-page page"},[_c('div',{staticClass:"faq-page__container"},[_c('h1',{staticClass:"faq-page__title"},[_vm._v("Вопросы и ответы")]),_c('div',{staticClass:"faq-page__content"},[_c('FaqSection')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }